import { fg } from '@atlassian/jira-feature-gating';
import { captureException } from '@atlassian/jira-capture-exception/src/index.tsx';

type GlobalThisVars = {
	__ATLASPACK_ERRORS?: Error[] | AtlaspackErrors;
};

class AtlaspackErrors extends Array<Error> {
	constructor(...args: Error[]) {
		super(...args);

		// Report errors immediately on initialisation, as atlaspack may have already pushed errors
		this.reportErrors();
	}

	push(...args: Error[]): number {
		const result = super.push(...args);

		// Report errors immediately after pushing
		this.reportErrors();

		return result;
	}

	/**
	 * Report errors in this array state to Sentry
	 */
	private reportErrors(): void {
		while (this.length > 0) {
			const error = this.shift();
			if (error) {
				captureException('atlaspack', error);
			}
		}
	}
}

export const handleAtlaspackErrors = () => {
	if (!fg('jira_atlaspack_errors_array_tracker')) return;

	// This variable is defined by Atlaspack, cast so we can have type safety in this file
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const globalVar = globalThis as unknown as GlobalThisVars;

	if (!(globalVar.__ATLASPACK_ERRORS instanceof AtlaspackErrors)) {
		globalVar.__ATLASPACK_ERRORS = new AtlaspackErrors(...(globalVar.__ATLASPACK_ERRORS ?? []));
	}
};
